import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
export function BonusesSection() {
  const bonuses = [{
    title: 'Guía de Comunicación Íntima',
    description: 'Aprendé a expresar lo que querés sin vergüenza y a leer el lenguaje corporal de tu pareja para conectar a otro nivel.',
    value: '$22.000'
  }, {
    title: '15 Posiciones que Potencian el Placer',
    description: 'Combiná técnicas orales con estas posiciones explosivas para un placer total e inolvidable.',
    value: '$25.000'
  }, {
    title: 'Audio Guía de Relajación Sensual',
    description: 'Eliminá los nervios y conectá con tu lado más sensual antes de cada encuentro. Ideal para principiantes.',
    value: '$20.000'
  }, {
    title: 'Checklist de Confianza Personal',
    description: 'Paso a paso para sentirte segura, irresistible y dueña de la situación en cualquier momento.',
    value: '$21.000'
  }, {
    title: 'Guía de Juegos Previos Irresistibles',
    description: 'Descubrí cómo calentar el ambiente antes de aplicar las técnicas. El secreto que nadie te enseña.',
    value: '$23.000'
  }, {
    title: 'Manual de Seducción con la Mirada',
    description: 'Aprendé a usar el contacto visual como arma de seducción. La mirada correcta lo cambia todo.',
    value: '$20.000'
  }, {
    title: 'Guía de Respiración y Control',
    description: 'Técnicas de respiración que te permiten durar más, disfrutar más y dar un placer que no se olvida.',
    value: '$24.000'
  }, {
    title: 'E-book: Secretos del Lenguaje Corporal Íntimo',
    description: 'Leé las señales de tu pareja como una experta. Sabé exactamente qué hacer y cuándo hacerlo.',
    value: '$22.000'
  }, {
    title: 'Guía de Fantasías y Juegos de Rol',
    description: 'Ideas creativas para romper la rutina y llevar la intimidad a un nivel que nunca imaginaste.',
    value: '$25.000'
  }, {
    title: 'Kit de Masajes Sensuales Paso a Paso',
    description: 'Aprendé las zonas erógenas clave y cómo usar tus manos para preparar el momento perfecto antes de cada técnica.',
    value: '$23.000'
  }, {
    title: 'Actualizaciones de por Vida',
    description: 'Cada nueva técnica, guía o material que agreguemos en el futuro, lo recibís totalmente gratis. Para siempre.',
    value: '$23.000'
  }];
  const totalValue = bonuses.reduce((sum, b) => {
    const num = parseInt(b.value.replace(/[$.]/g, '').replace(',', ''));
    return sum + num;
  }, 0);
  return <section className="py-24 bg-[#0D0118] relative px-4 sm:px-6 lg:px-8" data-id="element-20">
      <div className="max-w-7xl mx-auto" data-id="element-21">
        <div className="text-center mb-16" data-id="element-22">
          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[#FF2D8A]/20 mb-6" data-id="element-23">
            <GiftIcon className="w-10 h-10 text-[#FF2D8A]" data-id="element-24" />
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white mb-4" data-id="element-25">
            🎁 BONOS EXCLUSIVOS QUE <br className="hidden sm:block" data-id="element-26" />
            <span className="text-[#FFD700]" data-id="element-27">SOLO VAS A ENCONTRAR ACÁ</span>
          </motion.h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-28">
            Llevate{' '}
            <span className="text-white font-bold" data-id="element-29">10 bonos increíbles</span> de
            regalo al acceder hoy. Nadie te da tanto.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-30">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.07
        }} className="relative bg-white/5 backdrop-blur-lg border border-white/10 p-6 rounded-2xl hover:bg-white/10 transition-all duration-300 group overflow-hidden flex flex-col sm:flex-row sm:items-center gap-4" data-id="element-31">
              <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-[#FF2D8A]/15 to-transparent rounded-bl-full -z-10 transition-transform group-hover:scale-110" data-id="element-32"></div>

              {/* Number badge */}
              <div className="shrink-0 w-14 h-14 rounded-xl bg-gradient-to-br from-[#FF2D8A] to-[#9D00FF] flex items-center justify-center shadow-[0_0_15px_rgba(255,45,138,0.3)]" data-id="element-33">
                <span className="text-white font-black text-xl" data-id="element-34">
                  {(index + 1).toString().padStart(2, '0')}
                </span>
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0" data-id="element-35">
                <h3 className="text-lg font-bold text-white mb-1" data-id="element-36">
                  {bonus.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-37">
                  {bonus.description}
                </p>
              </div>

              {/* Price */}
              <div className="shrink-0 flex flex-row sm:flex-col items-center sm:items-end gap-2 sm:gap-1" data-id="element-38">
                <span className="text-base font-bold text-red-400 line-through decoration-red-500/60 decoration-2" data-id="element-39">
                  {bonus.value}
                </span>
                <span className="text-lg font-black text-[#22C55E] uppercase tracking-wide" data-id="element-40">
                  GRATIS
                </span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-16 text-center bg-gradient-to-r from-[#1A0230] to-[#2A044A] p-8 rounded-3xl border border-[#FF2D8A]/30 max-w-3xl mx-auto shadow-[0_0_30px_rgba(255,45,138,0.15)]" data-id="element-41">
          <p className="text-xl text-white mb-2" data-id="element-42">
            Valor total de los 10 bonos:
          </p>
          <p className="text-4xl font-bold text-red-400 line-through mb-4" data-id="element-43">
            ${totalValue.toLocaleString('es-AR')} ARS
          </p>
          <p className="text-2xl text-gray-300" data-id="element-44">
            Te llevás{' '}
            <span className="font-bold text-white" data-id="element-45">TODO ESTO GRATIS</span>{' '}
            incluido en tu acceso por solo{' '}
            <span className="text-[#FFD700] font-black text-3xl" data-id="element-46">
              $14.999 ARS
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}